module.exports = __webpack_public_path__ + "static/media/logo.cb7bc9df.svg";